import React from 'react';
import ImportModal from '../common/ImportModal';
import { useTranslation } from 'react-i18next';

const ProductSizeImportModal = ({
  isOpen,
  onClose,
  onImport,
  importing = false,
  importError = null,
  importSuccess = false,
}) => {
  const { t } = useTranslation();

  // Per-column guidance for the template's "Instructions" sheet.
  const NOTES = t('importTemplate.notes', { returnObjects: true });
  const TEMPLATE_COLUMN_SPECS = {
    alias_name: { required: true },
    product_size: { required: true },
    product_weight: { required: false, note: NOTES.weightKgPerPiece },
    standard_length: { required: false, note: NOTES.standardLengthM },
    product_thickness: { required: false },
    current_stock: { required: false, note: NOTES.wholeNumber },
    minimum_stock: { required: false, note: NOTES.wholeNumber },
    product_category_name: { required: true, note: NOTES.matchCategory },
    product_catalogue_name: { required: true, note: NOTES.matchSubCategory },
  };

  const importConfig = t('productSizes.import.config', { returnObjects: true });

  return (
    <ImportModal
      isOpen={isOpen}
      onClose={onClose}
      onImport={onImport}
      importing={importing}
      importError={importError}
      importSuccess={importSuccess}
      templateHeaders={importConfig.templateHeaders}
      templateColumnSpecs={TEMPLATE_COLUMN_SPECS}
      templateFilename={importConfig.templateFilename}
      inputId={importConfig.inputId}
      skipHeaderValidation={true}
    />
  );
}; 

export default ProductSizeImportModal;